import { useState, useEffect } from "react"
import PropTypes from "prop-types"

import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"

import { fetchRecommendedApplets } from "./api"
import Header from "./header"
import Subtitle from "./subtitle"
import Spinner from "shared/components/spinner"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import "./recommended_applets.scss"

const RecommendedApplets = ({ newUserOnboarding, urls }) => {
  const [loading, setLoading] = useState(false)
  const [applets, setApplets] = useState([])

  useEffect(() => {
    const effect = async () => {
      setLoading(true)
      const result = await fetchRecommendedApplets()
      setApplets(result)
      setLoading(false)
    }
    effect()
  }, [])

  const subtitleCopy = `We picked these Applets just for you. Tap any card to enable
    <br />
    your first automation.`

  return (
    <>
      <Header title="Recommended Applets" />
      <div styleName="container">
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Subtitle>{subtitleCopy}</Subtitle>
            <ul className="web-applet-cards">
              {applets.map(applet => (
                <li
                  className="my-web-applet-card web-applet-card"
                  key={applet.id}
                >
                  <SmallAppletCard
                    appletPath={appletOrConnectionPath(applet)}
                    applet={applet}
                    target="_blank"
                    onAppletClick={() =>
                      logIFTTTNextAction("click", {
                        object_type: newUserOnboarding
                          ? "onboarding_recommended_applet"
                          : "onboarding_recommended_applet_wizard",
                        object_id: applet.id,
                        location_type: "onboarding_recommendations",
                      })
                    }
                  />
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <footer styleName="recommendation-footer">
        <div styleName="wide-content">
          <div>
            Learn how to automate and integrate every thing in your life.
          </div>
          <a href={urls.exploreUrl} className="button-tertiary button-on-color">
            Get started
          </a>
        </div>
        <div styleName="narrow-content">
          <a href={urls.exploreUrl} className="button-tertiary button-on-color">
            Get started
          </a>
        </div>
      </footer>
    </>
  )
}

RecommendedApplets.propTypes = {
  newUserOnboarding: PropTypes.bool,
  urls: PropTypes.shape({
    exploreUrl: PropTypes.string.isRequired,
  }),
}

export default RecommendedApplets
